var mzg;
if (!mzg) {
    mzg = {};
}

$.extend(mzg,
    /**
     * @lends mzg
     */
    {
        /**
         * @namespace
         * @description mobile Menu
         */
        mobileMenu: {
            /**
             * @type {function}
             * @description initialize mobile Menu
             */
            data: null,
            mobileTopMenuItems: $('.header__meta').clone(),
            init: function() {                       

                $("#mobileMenu").mmenu({
                        // options
                        slidingSubmenus: true,
                        extensions: [
                            "pagedim-black",
                            //"position-right",
                            "border-none",
                            "position-front",
                            "shadow-menu",
                            "shadow-panels"
                        ],
                        iconPanels: false,
                        navbar: {
                            title: ""
                        },
                        navbars: [
                            {
                                "position": "top",
                                "content": [
                                    mzg.mobileMenu.mobileTopMenuItems,
                                    'close'
                                ]                            
                            }
                        ]
                    }, {
                        // configuration
                        offCanvas: {
                            pageSelector: "#js-mmenu-wrapper"
                        },
                        classNames: {
                            fixedElements: {
                                //fixed: "fix",
                                //sticky: "sticky-top"
                            }
                        }
                    });
                
                //remove classnames from cloned mobile menu so no css overwrites are needed
                var mmenu = $('#mmenu');

                mmenu
                    .find('.mm-panel.dropdown-menu')
                    .removeClass('dropdown-menu');
                

                mzg.mobileMenu.data = $("#mobileMenu").data("mmenu");
                mzg.mobileMenu.eventHandling();
                    
            },
            eventHandling: function(){
                
                $(document).on('click', '.navbar-toggler', function(){
					mzg.mobileMenu.data.open();
				});
                
                $(document).on('click', '.navbar-close', function(){
					mzg.mobileMenu.data.close();
				});
                
            }
        }
    }
);

$(mzg.mobileMenu.init);
